import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router"
import useTitle from "@/hooks/useTitle"

import EtEtTrinityIcon6SVGComp from "@/assets/img/icons/svgComp/EtEtTrinityIcon6SVGComp";

// 13 May 2025
import { useGetUsersQuery } from '@/features/users/usersApiSlice'

// 16 May 2025
import { useGetUserSetupStatussQuery } from "@/features/userSetupStatuss/userSetupStatussApiSlice"

// 09 Mar 2025
import EtTrinityWebLandingWelcome from './webLanding/EtTrinityWebLandingWelcome'
import EtTrinityWebLandingAction from './webLanding/EtTrinityWebLandingAction'

// 09 Apr 2025
import EtTrinityWebLandingCelebration from './webLanding/EtTrinityWebLandingCelebration'

// 10 Mar 2025
import EtHomeActionsIconSVGComp from "@/assets/img/icons/svgComp/EtHomeActionsIcon1SVGComp";
import EtHomeWelcomeIconSVGComp from "@/assets/img/icons/svgComp/EtHomeWelcomeIcon1SVGComp";

// 12 Mar 2025
import EtRunMarkIconSVGComp from "@/assets/img/icons/svgComp/EtRunMarkIcon3SVGComp";
import EtRunSetIconSVGComp from "@/assets/img/icons/svgComp/EtRunSetIcon1SVGComp";
import EtRunGoIconSVGComp from "@/assets/img/icons/svgComp/EtRunGoIcon1SVGComp";

// 09 Apr 2025
import EtRunFinishIconSVGComp from "@/assets/img/icons/svgComp/EtRunFinishIcon1SVGComp";

// 15 May 2025
import EtStartHereIconSVGComp from "@/assets/img/icons/svgComp/EtStartHereIconSVGComp";

// 08 Jul 2025
import EtAccountPlanVisualSample from "@/components/common/accounts/EtAccountPlanVisualSample"
import EtAccountPlanFlowSample from "@/components/common/accounts/EtAccountPlanFlowSample"
import EtVisualAccountPlan from "@/components/common/accounts/EtVisualAccountPlan"


// 03 Mar 2026
import EtTrinityPurposeNativeBoard from './webLanding/purposeNative/EtTrinityPurposeNativeBoard'

const EtTrinityWebLanding = ({username="", userId="", userOrgId="", profileInfo={}}) => {

  // Author - Atul Pandey
  // First Created - 07 Mar 2025
  // Purpose to act as the home page for Trinity Landing
  // Updated - 14 Mar 2025 - added username prop to the component and to pass it to other components called from here - i.e. EtTrinityWebLandingAction
  // Updated - 08 Apr 2025 - added userId prop to the component and to pass it to other components called from here - i.e. EtTrinityWebLandingAction
  // Updated - 08 Apr 2025 - added userId and userOrgId
  // Updated - 09 Apr 2025 - added celebrations section
  // Updated - 13 May 2025 - context for EtTrinityWebLandingWelcome
  // Updated - 14 May 2025 - Refactored the top bar to side bar
  // Updated - 16 May 2025 - Refactored to get the user's setup status to pass to Trinity Guided service bar via context
  // Updated - 19 May 2025 - Added profileInfo to get isAdmin, isOrgAdmin flags
  // Updated - 21 May 2025 - Added token - extracted from the profileInfo prop
  // Updated - 21 May 2025 - removed token prop and added email in UserInfo
  // Updated - 03 Mar 2026 - refactored the LH and RH panes into one and moved the LH pane menu items to the to of the single pane
  // Updated - 06 Mar 2026 - refactored the section button styling (Board, Power Up, Go, Celebrate)

  // 0 - Validate Data
  // console.log('UserId in TrinityWebLanding', userId)
  // console.log('UserOrgId in TrinityWebLanding', userOrgId)
  // console.log('profileInfo prop in TrinityWebLanding', profileInfo)
  
  // 1a - Set Page Title
    useTitle('Trinity Home')
  
  // 1b1 - State variables to show / hide sections
  // const [ activeTab, setActiveTab ] = useState("actions") // 08 Mar 2025
  const [ activeTab, setActiveTab ] = useState("welcome") // 08 Mar 2025

  // 2a - Data from RTK queries
  const {data: usersData } = useGetUsersQuery()
  const {data: userSetupStatussData} = useGetUserSetupStatussQuery() // 16 May 2025
  

  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  // 2b - Extract data from adapters and build data for other components
  const userInfo = extractEntitiesFromAdapter(usersData)?.filter(item => item.username === username)
  const userSetupStatuss = extractEntitiesFromAdapter(userSetupStatussData) // 16 May 2025

  const userHasActions = userSetupStatuss[0]?.userActionSetupStatus 
  const userHasTrailExecutions = userSetupStatuss[0]?.userTrailSessionExecutionSetupStatus;
  const userHasAccomplishments = userSetupStatuss[0]?.userWABSetupStatus
  const userHasGoogleCalendarSetup = userSetupStatuss[0]?.userProfileCalendarGoogleSetupStatus
  const userHasContacts = userSetupStatuss[0]?.userProfileContactSetupStatus

  const isUserEtAdmin = profileInfo?.isAdmin // 19 May 2025
  const isUserOrgAdmin = profileInfo?.isOrgAdmin // 19 May 2025
  // const token = profileInfo?.token // 21 May 2025
  const email = profileInfo?.email // 21 May 2025
  
  // console.log("isUserEtAdmin", isUserEtAdmin)
  // console.log("isUserOrgAdmin", isUserOrgAdmin)

  const userContextSetup = {
    userHasAcctions: userHasActions,
    userHasTrailExecutions: userHasTrailExecutions,
    userHasAccomplishments: userHasAccomplishments,
    userHasGoogleCalendarSetup: userHasGoogleCalendarSetup,
    userHasContacts: userHasContacts,
    isUserEtAdmin: isUserEtAdmin,                           // 19 May 2025
    isUserOrgAdmin: isUserOrgAdmin,                         // 19 May 2025
  }

  // console.log('userInfo in EtTrinityWebLanding', userInfo)
  
  // 2c - Context for EtTrinityWebLandingWelcome - 13 May 2025
  const context = {
    userInfo: userInfo,
    userContextSetup: userContextSetup,
    // token: token,                                           // 21 May 2025
    email: email,                                           // 21 May 2025
    message: "hello!",
  }

  // console.log('context', context)

  // 3 - navTabs - 06 Mar 2026
  const navTabs = [
    {
      key: "board",
      label: "Board!",
      Icon: EtStartHereIconSVGComp,
    },
    {
      key: "welcome",
      label: "Power up!",
      Icon: EtRunMarkIconSVGComp,
    },
    {
      key: "actions",
      label: "Go!",
      Icon: EtRunGoIconSVGComp,
    },
    {
      key: "celebrations",
      label: "Celebrate!",
      Icon: EtRunFinishIconSVGComp,
    },
  ];


  return (

    <div className='flex flex-col h-[85vh] font-poppins'> {/* Main container: sidebar + content */}
    
  {/* 03 Feb 2026 - Top Tabs */}
    <div className="bg-white p-2 flex items-center space-x-2">

      {/* 06 Mar 2026 - Removed DRY code */}
      {navTabs.map(({ key, label, Icon }) => (
        <div
          key={key}
          onClick={() => setActiveTab(key)}
          className={`flex items-center px-3 py-2 rounded-full cursor-pointer ${
            activeTab === key
              ? "bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 text-white hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-orange-900 font-bold tracking-widest uppercase shadow-lg shadow-gray-800"
              : "bg-gray-100 border border-gray-200 shadow"
          }`}
        >
          <Icon className={`h-6 w-6 ${
            activeTab === key
              ? "" :"text-orange-600" }`} />
          <span className="text-xs ml-2">{label}</span>
        </div>
      ))}



      {/* Prior Code - Commented - 06 Mar 2026 */}
      {/* <div
        onClick={() => setActiveTab("board")}
        className={`flex items-center px-3 py-2 rounded cursor-pointer shadow-lg shadow-black hover:bg-gradient-to-r hover:from-orange-600 hover:to-orange-600 hover:via-orange-800 hover:text-white ${
          activeTab === "board" ? "bg-black text-orange-600 font-semibold" : "bg-black text-gray-600"
        }`}
      >
        <EtStartHereIconSVGComp className="h-6 w-6" />
        <span className="text-xs ml-2">Board</span>
      </div>

      <div
        onClick={() => setActiveTab("welcome")}
        className={`flex items-center px-3 py-2 rounded cursor-pointer shadow-lg shadow-black hover:bg-gradient-to-r hover:from-orange-600 hover:to-orange-600 hover:via-orange-800 hover:text-white ${
          activeTab === "welcome" ? "bg-black text-orange-600 font-semibold" : "bg-black text-gray-600"
        }`}
      >
        <EtRunMarkIconSVGComp className="h-6 w-6" />
        <span className="text-xs ml-2">Power up!</span>
      </div>

      <div
        onClick={() => setActiveTab("actions")}
        className={`flex items-center px-3 py-2 rounded cursor-pointer shadow-lg shadow-black hover:bg-gradient-to-r hover:from-orange-600 hover:to-orange-600 hover:via-orange-800 hover:text-white ${
          activeTab === "actions" ? "bg-black text-orange-600 font-semibold" : "bg-black text-gray-600"
        }`}
      >
        <EtRunGoIconSVGComp className="h-6 w-6" />
        <span className="text-xs ml-2">Go!</span>
      </div>

      <div
        onClick={() => setActiveTab("celebrations")}
        className={`flex items-center px-3 py-2 rounded cursor-pointer shadow-lg shadow-black hover:bg-gradient-to-r hover:from-orange-600 hover:to-orange-600 hover:via-orange-800 hover:text-white ${
          activeTab === "celebrations" ? "bg-black text-orange-600 font-semibold" : "bg-black text-gray-600"
        }`}
      >
        <EtRunFinishIconSVGComp className="h-6 w-6" />
        <span className="text-xs ml-2">Celebrate!</span>
      </div> */}

    </div>
  
  
  {/* Sidebar */}
  {/* <div className='bg-gray-200 p-2 rounded shadow-md flex flex-col space-y-2'>
    <div 
      onClick={() => setActiveTab("welcome")}
      className={`flex flex-col items-center px-2 py-2 rounded cursor-pointer shadow-lg shadow-black hover:bg-gradient-to-r hover:from-orange-600 hover:to-orange-600 hover:via-orange-800 hover:text-white  ${
        activeTab === "welcome" ? "bg-black text-orange-600 font-semibold" : "bg-black text-gray-600"
      }`}
    > 
        <EtRunMarkIconSVGComp className='h-8 w-8' />
     
      <span className='text-xs mt-2 border-t border-gray-400'>Power up!</span>
    </div>

    <div 
      onClick={() => setActiveTab("actions")}
      className={`flex flex-col items-center px-2 py-2 rounded cursor-pointer shadow-lg shadow-black hover:bg-gradient-to-r hover:from-orange-600 hover:to-orange-600 hover:via-orange-800 hover:text-white ${
        activeTab === "actions" ? "bg-black text-orange-600 font-semibold" : "bg-black text-gray-600"
      }`}
    >
      <EtRunGoIconSVGComp className='h-8 w-8' />
      <div className='mt-2 border-t w-full text-center border-gray-400'>
        <span className='text-xs'>Go!</span>
      </div>
    </div>

    <div 
      onClick={() => setActiveTab("celebrations")}
      className={`flex flex-col items-center px-2 py-2 rounded cursor-pointer shadow-lg shadow-black hover:bg-gradient-to-r hover:from-orange-600 hover:to-orange-600 hover:via-orange-800 hover:text-white ${
        activeTab === "celebrations" ? "bg-black text-orange-600 font-semibold" : "bg-black text-gray-600"
      }`}
    >
      <EtRunFinishIconSVGComp className='h-8 w-8' />
      <div className='mt-2 border-t w-full text-center border-gray-400'>
        <span className='text-xs'>Celebrate!</span>
      </div>
      
    </div>

  </div> */}

  {/* Main Content */}
  {/* <div className='ml-1 bg-gray-100 w-full rounded overflow-y-auto'> */}
  <div className='mt-1 bg-gray-100 w-full rounded overflow-y-auto flex-1'>

    {activeTab === 'start' && (
      
      <div>
        {/* <p>Start</p> */}
        {/* <EtAccountPlanVisualSample /> */}
        {/* <EtAccountPlanFlowSample /> */}
        <EtVisualAccountPlan />
      </div>
    )}

    {/* 03 Mar 2026 */}
    {activeTab === "board" && (
      <EtTrinityPurposeNativeBoard username={username} userId={userId} userOrgId={userOrgId} />
    )}

    {activeTab === 'welcome' && (
      <EtTrinityWebLandingWelcome context={context} userId={userId} userOrgId={userOrgId} />
    )}

    {activeTab === 'actions' && (
      <EtTrinityWebLandingAction username={username} userId={userId} userOrgId={userOrgId} />
    )}

    {activeTab === 'celebrations' && (
      <EtTrinityWebLandingCelebration username={username} userId={userId} userOrgId={userOrgId} />
    )}

  </div>
</div>



    // <div className='mx-auto'>
    //     <div className='flex justify-start items-center m-1 p-1'>
          
    //       <div className='flex justify-center items-center cursor-pointer'>
    //         <div 
    //           onClick={() => setActiveTab("welcome")}
    //           className={`flex items-center font-bold mx-2 cursor-pointer ${
    //             activeTab === "welcome" ? "text-orange-600" : ""
    //           }`}
    //         >
    //           <EtRunMarkIconSVGComp className='h-8 w-8'/>
    //           <p className='mx-1 px-1 text-xs italic'>Power up!</p>
    //         </div> 
    //       </div>
    //       <div className='flex justify-center items-center cursor-pointer'>
    //         <div 
    //           onClick={() => setActiveTab("actions")}
    //           className={`flex items-center font-bold mx-2 cursor-pointer ${
    //             activeTab === "actions" ? "text-orange-600" : ""
    //           }`}
    //         >
    //           <EtRunGoIconSVGComp className='h-8 w-8'/>
    //           <p className='mx-1 px-1 text-xs italic'>Go!</p>
    //         </div>
    //       </div>
    //       <div className='flex justify-center items-center cursor-pointer'>
    //         <div 
    //           onClick={() => setActiveTab("celebrations")}
    //           className={`flex items-center font-bold mx-2 cursor-pointer ${
    //             activeTab === "celebrations" ? "text-orange-600" : ""
    //           }`}
    //         >
    //           <EtRunFinishIconSVGComp className='h-8 w-8'/>
    //           <p className='mx-1 px-1 text-xs italic'>Celebrate!</p>
    //         </div>
    //       </div>
        
    //     </div>

    //     <div className='border-t border-gray-400 my-2 py-2'>
    //       {activeTab === 'welcome' && (
    //         <div>
    //           <EtTrinityWebLandingWelcome context={context}/>
    //         </div>
    //       )}

    //       {activeTab === 'actions' && (
    //         <div>
    //           <EtTrinityWebLandingAction username={username} userId={userId} userOrgId={userOrgId}/> {/* 14 Mar 2025 ; 08 Apr 2025 - added userId and userOrgId*/}
    //         </div>
    //       )}

    //       {/* 09 Apr 2025 */}
    //       {activeTab === 'celebrations' && (
    //         <div>
    //           <EtTrinityWebLandingCelebration username={username} userId={userId} userOrgId={userOrgId}/> 
    //         </div>
    //       )}

    //     </div>
    // </div>
  )
}

export default EtTrinityWebLanding